import { mapCodeList } from 'redux/selectors/code-lists'

const GET_CODE_LISTS = 'dofe-bo/code-list/GET_CODE_LISTS'
const GET_CODE_LISTS_SUCCESS = 'dofe-bo/code-list/GET_CODE_LISTS_SUCCESS'
const GET_CODE_LISTS_FAIL = 'dofe-bo/code-list/GET_CODE_LISTS_FAIL'

const initialState = {
  genders: {
    loaded: false,
    list: []
  },
  titles: {
    loaded: false,
    list: []
  },
  phoneTypes: {
    loaded: false,
    list: []
  },
  nationalities: {
    loaded: false,
    list: []
  },
  employmentStatuses: {
    loaded: false,
    list: []
  },
  consentDeliveryTypes: {
    loaded: false,
    list: []
  },
  userRegistrationAssessmentStates: {
    loaded: false,
    list: []
  },
  ajEventCategories: {
    loaded: false,
    list: []
  },
  modeOfTransportTypeList: {
    loaded: false,
    list: []
  },
  organizationTypes: {
    loaded: false,
    list: []
  },
  projectLocationTypes: {
    loaded: false,
    list: []
  },
  onlinePaymentTypes: {
    loaded: false,
    list: []
  },
  assessorExemptionWWCReasonsTypes: {
    loaded: false,
    list: []
  },
  loading: false
}

export default function reducer(state = initialState, action = {}) {
  const newState = {}

  let requestedLists

  switch (action.type) {
    case GET_CODE_LISTS:
      return {
        ...state,
        loading: true
      }
    case GET_CODE_LISTS_SUCCESS:
      requestedLists = Object.keys(action.result).filter(
        key => action.result[key]
      )

      for (const list of requestedLists) {
        newState[list] = {
          list: mapCodeList(action.result[list], {
            listType: list,
            intlRequired: action.options.intlRequired
          }),
          loading: false,
          loaded: true
        }
      }

      return {
        ...state,
        ...newState,
        loading: false
      }
    case GET_CODE_LISTS_FAIL:
      return {
        ...state,
        loading: false
      }
    default:
      return state
  }
}

export function getLists(lists = '', options = {}) {
  return {
    types: [GET_CODE_LISTS, GET_CODE_LISTS_SUCCESS, GET_CODE_LISTS_FAIL],
    promise: client => client.get(`api/code-list?lists=${lists}`),
    options
  }
}
export function getPublicLists(lists = '', options = {}) {
  return {
    types: [GET_CODE_LISTS, GET_CODE_LISTS_SUCCESS, GET_CODE_LISTS_FAIL],
    promise: client =>
      client.get(
        `api/registration/code-list?lists=${lists}&with=CL_AWARD_LEVEL_TYPES`
      ),
    options
  }
}
